import React, { Component } from 'react';
import css from './VerticalNavigation.module.css';

class VerticalNavigation extends Component {
  items = null;
  constructor(props) {
    super(props);  

    this.items = this.props.items;
    this.state = {
        redraw:false
    }
  }

  componentDidMount(){
     this.props.getItemList(this.items);
  }

  onClick(value, index){
    this.changeItem(value, index);
  }

  changeItem(value, index){
    for(let selIndex = 0; selIndex < this.items.length; selIndex++){
      this.items[selIndex].isActive = false;
    }
    this.items[index].isActive = true;
    
    this.setState({redraw:!this.state.redraw});
  }

  filterList(list){
    let filteredList = [];
    let modules = this.props.data.Login.Modules;
    for(let menuIndex = 0; menuIndex < list.length; menuIndex++){
      for(let index = 0; index < modules.length; index++){
        if(modules[index] === list[menuIndex].value){
          let isPresent = false;
          // Have Uniq Item in the list
          for(let flIndex = 0; flIndex < filteredList.length; flIndex++){
              if(filteredList[flIndex].value === list[menuIndex].value){
                isPresent = true;
              }
          }
          if(!isPresent){
            filteredList.push(list[menuIndex]);
          }
        }
      }
    }

    this.items = filteredList;   
  }

  renderItems(){
    this.filterList(this.items); 
    let html = [];
    for(let index = 0; index < this.items.length; index++){
      html.push(<li key={"key"+index} className={this.items[index].isActive?css.active:null} onClick={this.onClick.bind(this,this.items[index].value,index)}>{this.items[index].text}</li>);
    }

    return html;
  }

  render() {
    return (
    <div>
        <ul className={css.ul}>
            {this.renderItems()}
        </ul>
     </div>
    );
  }
}

export default VerticalNavigation;